"use client"

import { Spinner } from "@/components/ui/spinner"

export function LoadingScreen() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background">
      <Spinner className="size-8 text-muted-foreground" />
    </div>
  )
}
